<!--Top Bar, Select Visitor-->
<div>
	<caass-ms-visitor-selector (VisitorChanged)="onVisitorChanged($event)"> </caass-ms-visitor-selector>
</div>

<!--Buttons-->
<div class="ButtonDiv">
	<button class="btn btn-primary" (click)="onAddVisitor()">Add Visitor</button>
	<button [disabled]="EditDisabled()" class="btn btn-primary SmallLeftMargin" (click)="onEditVisitor()">Edit Visitor</button>
</div>

<!--Tabs-->
<div>
	<p-tabView [(activeIndex)]="SelectedTab">
		<p-tabPanel>
			<ng-template pTemplate="header">
				<div class="HeaderOuterDiv">
					<div class="HeaderDiv">
						<i class="fa fa-user"></i>
						<span>Info</span>
					</div>
				</div>
			</ng-template>
			<caass-ms-visitor-info [SelectedVisitor]="SelectedVisitor"> </caass-ms-visitor-info>
		</p-tabPanel>

		<p-tabPanel>
			<ng-template pTemplate="header">
				<div class="HeaderOuterDiv">
					<div class="HeaderDiv">
						<i class="fa fa-calendar"></i>
						<span>History</span>
					</div>
				</div>
			</ng-template>
			<caass-ms-visitor-history [SelectedVisitor]="SelectedVisitor"> </caass-ms-visitor-history>
		</p-tabPanel>

		<p-tabPanel>
			<ng-template pTemplate="header">
				<div class="HeaderOuterDiv">
					<div class="HeaderDiv">
						<i class="fa fa-search"></i>
						<span>Offender Lookup</span>
					</div>
				</div>
			</ng-template>
			<caass-ms-visitor-offender-lookup [SelectedVisitor]="SelectedVisitor"> </caass-ms-visitor-offender-lookup>
		</p-tabPanel>

		<p-tabPanel>
			<ng-template pTemplate="header">
				<div class="HeaderOuterDiv">
					<div class="HeaderDiv">
						<i class="fa fa-calendar-check-o"></i>
						<span>Lookup History</span>
					</div>
				</div>
			</ng-template>
			<caass-ms-visitor-offender-lookup-history [SelectedVisitor]="SelectedVisitor"> </caass-ms-visitor-offender-lookup-history>
		</p-tabPanel>

		<!--
        *NOTE: Need DB Changes? One Person per entry in Parent Table 
        Ex. If a parent has 2 kids they have 2 entries in the Person Table
        (And there's no connection between them, but they have the same name)
        -->

		<!--
        <p-tabPanel>
            <ng-template pTemplate="header">
                <div class="HeaderOuterDiv">
                    <div class="HeaderDiv">
                        <i class="fa fa-graduation-cap"></i>
                        <span>Parent/Child</span>
                    </div>
                </div>
            </ng-template>
            <caass-ms-visitor-parent-child
                [SelectedVisitor]="SelectedVisitor">
            </caass-ms-visitor-parent-child>
        </p-tabPanel>
        -->

		<p-tabPanel>
			<ng-template pTemplate="header">
				<div class="HeaderOuterDiv">
					<div class="HeaderDiv">
						<i class="fa fa-users"></i>
						<span>Aliases</span>
					</div>
				</div>
			</ng-template>
			<caass-ms-visitor-aliases [SelectedVisitor]="SelectedVisitor"> </caass-ms-visitor-aliases>
		</p-tabPanel>
	</p-tabView>
</div>
